<h2>{{ "sdp.welcome.to" | translate }} {{ "application.title" | translate }}</h2>
<p class="sdp-home-header-info">{{ "application.title" | translate }} {{ "home.info.block.1" | translate }}
</p>
<div class="sdp-home-help">
	<mat-card class="sdp-home-help-card">
		<sdp-icon [icon]="helpIcon"></sdp-icon>
		<div class="sdp-home-help-text">
			<a
				href="https://impulsepoint.atlassian.net/wiki/spaces/CMKB/pages/428802172/SafeConnect+SDP+Demo+Deployment+Guide"
				target="_blank"
			>{{ "home.link.help" | translate }}</a>
			{{ "home.area.help.description" | translate}}
		</div>
	</mat-card>
</div>
<div class="sdp-home-area-header">{{ "home.area1.header" | translate }}</div>
<div class="sdp-home-area">
	<div class="sdp-home-section">
		<a
			routerLink="/wizard/applications"
			class="sdp-a-default"
		>
			<sdp-icon [icon]="applicationsIcon"></sdp-icon>
			{{ "home.link.applications" | translate }}
		</a>
	</div>
	<div class="sdp-home-section">
		<a
			routerLink="/wizard/users"
			class="sdp-a-default"
		>
			<sdp-icon [icon]="usersIcon"></sdp-icon>
			{{ "home.link.users" | translate }}
		</a>
	</div>
	<div class="sdp-home-section">
		<a
			routerLink="/wizard/policies"
			class="sdp-a-default"
		>
			<sdp-icon [icon]="policiesIcon"></sdp-icon>
			{{ "home.link.policies" | translate }}
		</a>
	</div>
</div>
<div class="sdp-home-area-header">{{ "home.area2.header" | translate }}</div>
<div class="sdp-home-area">
	<div class="sdp-home-section">
		<a
			href="{{ downloadUrl }}"
			target="_blank"
			class="sdp-a-default"
		>
			<sdp-icon [icon]="downloadIcon"></sdp-icon>
			{{ "home.link.download" | translate }}
		</a>
	</div>
	<div class="sdp-home-section">
		<a
			routerLink="/wizard/access"
			class="sdp-a-default"
		>
			<sdp-icon [icon]="inviteIcon"></sdp-icon>
			{{ "home.link.invite-download" | translate }}
		</a>
	</div>
</div>
<div class="sdp-home-area-header">{{ "home.area3.header" | translate }}</div>
<div class="sdp-home-area">
	<div class="sdp-home-section">
		<a
			routerLink="/administration"
			class="sdp-a-default"
		>
			<sdp-icon [icon]="manageIcon"></sdp-icon>
			{{ "home.link.admin" | translate }}
		</a>
	</div>
</div>